import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-makery-event-product',
  templateUrl: './makery-event-product.component.html',
  styleUrls: ['./makery-event-product.component.scss']
})
export class MakeryEventProductComponent implements OnInit {

  @Input() event;
  constructor() { }

  ngOnInit() {
  }

}
